import { useParams } from "react-router";

import { useCompanyFlagsData } from "@/company/data/useCompanyFeaturesData";

import { CompanyFlagsTable } from "../components/CompanyFeaturesTable";

export default function CompanyFlags() {
  const { companyId } = useParams();
  const { data, isLoading, isFetching, isError, refetch } =
    useCompanyFlagsData(companyId);

  return (
    <CompanyFlagsTable
      data={data}
      isError={isError}
      isFetching={isFetching}
      isLoading={isLoading}
      onRetry={refetch}
    />
  );
}
